import React from 'react';
import Authorization from '../apps/Authorization/components';

const AuthorizationPage = () => {
  return (
    <Authorization/>
  );
};

export default AuthorizationPage;